module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/pedal-v2-6734f36ce979fc4160e92a1f469352cd.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/pedal-v2.svg
// module id = BJ29
// module chunks = 1 3 10 12 18